// Copyright (c) 2022 by Move Closer

import { AsyncComponent } from 'vue'

/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
export enum CTABoxModuleVersion {
  Default= 'default',
  Linked = 'linked',
  Promo = 'promo',
  Box = 'box',
  Banner = 'banner',
  Video = 'video',
  Light = 'light',
}

/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
export const ctaBoxModuleVersionsRegistry: Record<string, AsyncComponent> = {
  [CTABoxModuleVersion.Default]: () => import(
    /* webpackChunkName: "modules/CTABoxDefault" */
    './versions/Default.vue'
  ),
  [CTABoxModuleVersion.Linked]: () => import(
    /* webpackChunkName: "modules/CTABoxLinked" */
    './versions/Linked.vue'
  ),
  [CTABoxModuleVersion.Promo]: () => import(
    /* webpackChunkName: "modules/CTABoxPromo" */
    './versions/Promo.vue'
  ),
  [CTABoxModuleVersion.Box]: () => import(
    /* webpackChunkName: "modules/CTABoxBox" */
    './versions/Box.vue'
  ),
  [CTABoxModuleVersion.Banner]: () => import(
    /* webpackChunkName: "modules/CTABoxBanner" */
    './versions/Banner.vue'
  ),
  [CTABoxModuleVersion.Video]: () => import(
    /* webpackChunkName: "modules/CTABoxVideo" */
    './versions/Video.vue'
  ),
  [CTABoxModuleVersion.Light]: () => import(
    /* webpackChunkName: "modules/CTABoxLight" */
    './versions/Light.vue'
  ),
}
